/**
 * Browser-side download of a GDPR export bundle. The export endpoints return the full record as
 * JSON; we hand it to the operator as a downloadable file (Article 20 portability — the salon gives
 * the person a machine-readable copy of everything held about them).
 *
 * This is purely client-side: serialise → Blob → object URL → click a synthetic <a>. No network, so
 * nothing to queue — it runs only after the live export fetch has already resolved (online-only).
 */
export function downloadJson(filename: string, payload: unknown): void {
  const json = JSON.stringify(payload, null, 2);
  const blob = new Blob([json], { type: 'application/json' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke on the next tick so the click has dispatched before the URL is freed.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

/** A filesystem-safe slug for an export filename (e.g. "jane-doe" → salonomy-export-jane-doe-…). */
export function exportFilename(label: string): string {
  const slug =
    label
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '')
      .slice(0, 60) || 'export';
  const stamp = new Date().toISOString().slice(0, 10);
  return `salonomy-export-${slug}-${stamp}.json`;
}
